export default __webpack_public_path__ + "static/media/Download.d6da94d1.svg";